import TagManager from "react-gtm-module";

const LiveChat = (): void => {
  const startChatButton: any = document.querySelector("#startChatButton");
  if (startChatButton) {
    startChatButton.addEventListener("click", function () {
      TagManager.dataLayer({
        dataLayer: {
          LiveChatFlag: "Interaction",
          nonInteraction: true,
        },
      });
    });
  }
};
LiveChat();
